import { addActiveState, removeActiveState } from './HandleActiveState'

export const handleScroll = (navItems, listItems, isScrollingCallback) => {
  let components = []
  let timeout
  let closestComponent = { component: null }

  const setActiveItem = (isSticky) => {
    closestComponent = components.reduce((prev, curr) => {
      const scrollYOffset = window.scrollY - curr.offsetTop

      const isInView = isSticky ? scrollYOffset > -300 : scrollYOffset > 0

      return !prev.component || isInView ? { component: curr } : prev
    }, closestComponent)

    removeActiveState(listItems)

    listItems.forEach((item) => {
      if (item.dataset.name === closestComponent.component.id) {
        addActiveState(item)
      }
    })
  }

  const doScroll = () => {
    const stickyNavClass = 'sticky'
    const leftColumnContainer = document.getElementsByClassName('LeftNav')[0]
    const bottomContainer = document.getElementsByClassName(
      'TwoColumnLayout-bottomContainer'
    )[0]

    // Get height of NAV as it will be excluded later
    const navs = document.getElementsByTagName('nav')
    const navHeight = navs.length ? navs[0].offsetHeight : 0

    // Get "true offset top" of bottomContainer
    let stickyTopLimit = 0
    let parent = bottomContainer

    while (parent.offsetParent) {
      stickyTopLimit += parent.offsetTop

      parent = parent.offsetParent
    }

    // Exclude "nav" height because it will also be "sticky"
    stickyTopLimit -= navHeight

    const isSticky = window.scrollY >= stickyTopLimit && window.innerWidth > 767

    if (isSticky) {
      leftColumnContainer.classList.add(stickyNavClass)
    } else {
      leftColumnContainer.classList.remove(stickyNavClass)
    }

    // Update left nav (but only if we're scrolling from mouse, not from clicking left nav)
    if (timeout || isScrollingCallback()) {
      return
    }

    timeout = setTimeout(() => {
      setActiveItem(isSticky)

      timeout = null
    }, 250)
  }

  const getDOMComponents = () => {
    navItems.map((item) => {
      const componentId = item.navAnchor
      const component = document.getElementById(componentId)

      if (component) {
        components.push(component)
      }
    })
  }

  document.addEventListener('DOMContentLoaded', getDOMComponents)

  doScroll()

  window.addEventListener('scroll', doScroll)
}
